<template>
  <div>
    <form id="formSiteSetupRegForms" @change="clearErrors()" class="d-flex flex-column" v-on:submit.prevent="updateRegistrationFormSettings">
      <div class="d-flex flex-column tab-card-form">
        <div class="element-info">
          <div class="row align-items-center">
            <div v-if="this.mobile" class="col-sm-8">
              <div class="element-info-with-icon justify-content-center">
                <div class="element-info-text text-center">
                  <h5 class="element-inner-header">Registration Form</h5>
                  <div class="element-inner-desc">Here you can specify criterias for the registration form.</div>
                </div>
              </div>
            </div>
            <div v-else class="col-sm-8">
              <div class="element-info-with-icon">
                <div class="element-info-icon">
                  <fontAwesomeIcon :icon="['fas', 'address-card']" size="2x" />
                </div>
                <div class="element-info-text ml-5">
                  <h5 class="element-inner-header">Registration Form</h5>
                  <div class="element-inner-desc">Here you can specify criterias for the registration form.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="project-box d-flex flex-column">
          <div class="row">
            <b-form-group class="mt-3 col-lg-4 col-sm-12">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupRegistrationForm.activated"
                  name="splitter_management"
                  :value="1"
                  :unchecked-value="0">
                  Registration feature activated
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-4 col-sm-12">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupRegistrationForm.active_checkbox"
                  name="show_activity_dashboard"
                  :value="1"
                  :unchecked-value="0">
                  Checkbox activated
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-4 col-sm-12">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupRegistrationForm.customer_name_is_mandatory"
                  name="show_activity_dashboard"
                  :value="1"
                  :unchecked-value="0">
                  Customer name is a mandatory field
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-4 col-sm-12">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupRegistrationForm.requester_name_is_mandatory"
                  name="splitter_management"
                  :value="1"
                  :unchecked-value="0">
                  Requester name is a mandatory field
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-4 col-sm-12">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupRegistrationForm.telephone_is_mandatory"
                  name="show_activity_dashboard"
                  :value="1"
                  :unchecked-value="0">
                  Telephone number is a mandatory field
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-4 col-sm-12">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupRegistrationForm.custom_field_is_mandatory"
                  name="show_activity_dashboard"
                  :value="1"
                  :unchecked-value="0">
                  Custom field is a mandatory field
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Registration administrator email</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input v-model="setupRegistrationForm.registration_admin_email" type="text"></b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span"> Main text</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <b-form-textarea class="txtbox-min-h" v-model="setupRegistrationForm.registration_text"></b-form-textarea>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Custom field label</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input v-model="setupRegistrationForm.custom_field_label"></b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Checkbox label</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input v-model="setupRegistrationForm.checkbox_label"></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">Send login details by</span></b-input-group-text>
                </b-input-group-prepend>
                <b-form-select v-model="setupRegistrationForm.send_details_by" class="text-capitalize">
                  <option value="email">email</option>
                  <option value="email_with_attachment">email with attachment</option>
                  <option value="post">post</option>
                </b-form-select>
              </b-input-group>
            </b-form-group>
          </div>
          <transition name="fade">
            <ValidationErrors v-if="getValidationErrors.validationName == 'siteSetupRegistrationForm'" class="mt-3"/>
          </transition>
          <transition name="fade">
            <ResponseInfo v-if="getResponseInfo.name == 'siteSetupRegistrationForm'" class="mt-3"/>
          </transition>
          <button v-if="!this.mobile" class="btn btn-primary mt-3 align-self-end" type="submit" value="submit">Update</button>
          <button v-else class="btn btn-secondary mt-3 align-self-end" type="submit" value="submit">Update</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'
import ValidationErrors from '@/components/ValidationErrors.vue'

export default{
  name: 'SiteSetupRegistrationForm',
  components: {
      ResponseInfo,
      ValidationErrors
  },
  data() {
    return {
      setupRegistrationForm: {},
      mobile: window.innerWidth <= 700
    }
  },
  created() {
    registrationFormSettings:{
        this.$store.dispatch('getRegistrationFormSettings')
        .then(() => {
            if(Object.keys(this.registrationFormSettings).length){
                this.setupRegistrationForm = Object.assign({}, this.registrationFormSettings)
            }
        })
    }
    window.addEventListener('resize', () => {
          this.mobile = window.innerWidth <= 700
    })
  },
  computed:{
      ...mapGetters(['allTemplateDetails', 'getUserDetails','getIsNewsnet', 'getRegistrationFormSettings', 'getResponseInfo', 'getValidationErrors']),
      registrationFormSettings:{
          get() {
              return this.$store.getters.getRegistrationFormSettings
          }
      }
  },
  methods: {
    clearErrors() {
      //clearing the error message when we change the input
      this.$store.commit('setValidationErrors', [])
    },
    updateRegistrationFormSettings(){
      this.$store.dispatch('setRegistrationFormSettings',{
          data: this.setupRegistrationForm
      })
    }
  }
}
</script>

<style lang="css" scoped>
.tab-card-form{
  min-width: 70%;
}
.txtbox-min-h{
  min-height: 150px;
}
.pretext{
  display: flex;
  align-items: center;
  justify-content: center;
}
.pretext-span{
  width: 100%;
  white-space: normal;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
